import {
  CountryCode,
  getCountries,
  getCountryCallingCode,
} from "libphonenumber-js";

interface PhonePrefixOption {
  value: string;
  label: string;
}

// Priority countries - displayed at the top of the list
const PRIORITY_COUNTRIES: CountryCode[] = ["PL", "UA"];

/**
 * Returns a list of phone prefix options for use with SelectFormMUI.
 * Poland (+48) is first, Ukraine (+380) is second, then all other countries sorted by prefix.
 */
export const getPhonePrefixOptions = (): PhonePrefixOption[] => {
  const countries = getCountries();

  // Create priority options (PL first, UA second)
  const priorityOptions: PhonePrefixOption[] = PRIORITY_COUNTRIES.map(
    (code) => ({
      value: `+${getCountryCallingCode(code)}`,
      label: `+${getCountryCallingCode(code)}`,
    })
  );

  // Get unique prefixes from non-priority countries
  const seenPrefixes = new Set(priorityOptions.map((opt) => opt.value));

  const otherOptions: PhonePrefixOption[] = countries
    .filter((code) => !PRIORITY_COUNTRIES.includes(code))
    .map((code) => {
      const prefix = `+${getCountryCallingCode(code)}`;
      return { value: prefix, label: prefix, code };
    })
    .filter((option) => {
      // Remove duplicates (some countries share the same prefix)
      if (seenPrefixes.has(option.value)) {
        return false;
      }
      seenPrefixes.add(option.value);
      return true;
    })
    .map(({ value, label }) => ({ value, label }))
    .sort((a, b) => {
      // Sort by numeric value of prefix
      const numA = parseInt(a.value.replace("+", ""), 10);
      const numB = parseInt(b.value.replace("+", ""), 10);
      return numA - numB;
    });

  return [...priorityOptions, ...otherOptions];
};

export const DEFAULT_PHONE_PREFIX = "+48";
